import type { ResponseModel } from 'common/interfaces';

export function processErrorMessages(messages: ResponseModel['messages']) {
  return messages.map(message => message.message).join('; ');
}
